import React, { useEffect, useState } from "react";
import "../../DashBoard/dashboard.css";
import { Box, Slider } from "@mui/material";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import creditRatingService from "../../../components/Services/creditRating.service";
import {
  getAllListingsConsumerLogin,
  getAllListingsGeneratorLogin,
} from "../../../store/ListingsSearch/actions";
import DateRangePicker from "rsuite/DateRangePicker";
import "rsuite/dist/rsuite.css";
import moment from "moment";
import "./listingsSearch.css";
import { getAllEnergyTypes } from "../../../store/ConsumerCapacity/action";
import CustomTimePicker from "../../../components/TimePicker/customTimePicker";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import endOfMonth from "date-fns/endOfMonth";
import endOfYear from "date-fns/endOfYear";

const ListingsSearchFilter = ({
  selectedCardData,
  getMatchingBankingListings,
}) => {
  const [credit, setCredit] = useState([]);
  const dispatch = useDispatch();
  const currentRoute = window.location.pathname;

  const role = useSelector((state) => state?.sessionState?.role);
  const energyTypes = useSelector(
    (state) => state?.consumerCapacityReducer?.energyTypes
  );

  const creditRating = () => {
    creditRatingService.getAllCreditRating().then((response) => {
      if (response) {
        setCredit(response?.data?.data);
      }
    });
  };

  const initialValues = {
    energy: [null, null],
    matchPercentage: "",
    energyRate: "",
    sellingCost: [null, null],
    landingCostRange: [null, null],
    creditRatingId: "",
    connectionStatus: "",
    dateRange: null,
    injectionDateRange: null,
    drawlDateRange: null,
    energyTypeId: "",
    startTime: "",
    endTime: "",
    injectionStartTime: "",
    injectionEndTime: "",
    drawlStartTime: "",
    drawlEndTime: "",
    timeOfDrawlFactor: [null, null],
    bankingFactor: [null, null],
  };
  const handleFormReset = () => {
    if (role === "CONSUMER" || role === "UN_VERIFIED_CONSUMER") {
      getAllListingsConsumerLogin()(dispatch);
    } else if (role === "GENERATOR" || role === "UN_VERIFIED_GENERATOR") {
      getAllListingsGeneratorLogin()(dispatch);
    }
  };
  useEffect(() => {
    creditRating();
    getAllEnergyTypes()(dispatch);
  }, []);
  const predefinedRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Tomorrow",
      value: [addDays(new Date(), 1), addDays(new Date(), 1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [new Date(), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "This month",
      value: [new Date(), endOfMonth(new Date())],
      placement: "left",
    },
    {
      label: "This year",
      value: [new Date(), endOfYear(new Date())],
      placement: "left",
    },
    {
      label: "Next week",
      closeOverlay: false,
      value: (value) => {
        const [start = new Date()] = value || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), 7),
        ];
      },
      appearance: "default",
    },
  ];
  const { beforeToday } = DateRangePicker;

  return (
    <>
      <Formik
        initialValues={initialValues}
        validateOnMount={false}
        onSubmit={(values, { setSubmitting }) => {
          const filteredData = {
            energy: {
              operation: "BETWEEN",
              key: role === "CONSUMER" ? "sellEnergy" : "purchaseEnergy",
              value: values.energy[0],
              value1: values.energy[1],
            },
            matchPercentage: {
              operation: "BETWEEN",
              key: "matchPercentage",
              value: 0,
              value1: values.matchPercentage,
            },
            sellingCost: {
              operation: "BETWEEN",
              key: "sellingCost",
              value: values.sellingCost[0],
              value1: values.sellingCost[1],
            },
            energyRate: {
              operation: "BETWEEN",
              key: "energyRate",
              value: 0,
              value1: values.energyRate,
            },
            landingCostRange: {
              operation: "BETWEEN",
              key: "landingCost",
              value: values.landingCostRange[0],
              value1: values.landingCostRange[1],
            },
            creditRatingId: {
              operation: "LIKE",
              key:
                role === "BANKING"
                  ? "company_creditRating_id"
                  : role === "CONSUMER"
                  ? "generatorPlant_company_creditRating_id"
                  : "consumerDetail_company_creditRating_id",
              value: values.creditRatingId,
              value1: null,
            },
            connectionStatus: {
              operation: "LIKE",
              key:
                values.connectionStatus === "PLACED" ||
                values.connectionStatus == ""
                  ? role === "CONSUMER"
                    ? "bids_consumerStatus"
                    : "bids_generatorStatus"
                  : role === "CONSUMER"
                  ? "bids_generatorStatus"
                  : "bids_consumerStatus",
              value: values.connectionStatus,
              value1: null,
            },
            dateStartAt: {
              operation: "LESS_THAN_EQUAL",
              key: "dateStartAt",
              value:
                values.dateRange &&
                moment(values.dateRange[1]).format("DD-MMM-yyyy"),
            },
            dateEndAt: {
              operation: "GREATER_THAN_EQUAL",
              key: "dateEndAt",
              value:
                values.dateRange &&
                moment(values.dateRange[0]).format("DD-MMM-yyyy"),
            },
            slotStartAt: {
              operation: "LESS_THAN_EQUAL",
              key: "slotStartAt",
              value: values.endTime && values.endTime,
            },
            slotEndAt: {
              operation: "GREATER_THAN_EQUAL",
              key: "slotEndAt",
              value: values.startTime && values.startTime,
            },
            consumerEnergyTypeId: {
              operation: "LIKE",
              key: "energyType_id",
              value: +values.energyTypeId,
            },
            discomEnergyTypeId: {
              operation: "LIKE",
              key: "energyType_id",
              value: +values.energyTypeId,
            },
            generatorEnergyTypeId: {
              operation: "LIKE",
              key: "generatorPlant_energyType_id",
              value: +values.energyTypeId,
            },
            bankingSlotInjects_dateStartAt: {
              operation: "LESS_THAN_EQUAL",
              key: "bankingSlotInjects_dateStartAt",
              value:
                values.injectionDateRange &&
                moment(values.injectionDateRange[1]).format("DD-MMM-yyyy"),
            },
            bankingSlotInjects_dateEndAt: {
              operation: "GREATER_THAN_EQUAL",
              key: "bankingSlotInjects_dateEndAt",
              value:
                values.injectionDateRange &&
                moment(values.injectionDateRange[0]).format("DD-MMM-yyyy"),
            },
            bankingSlotInjects_slotStartAt: {
              operation: "LESS_THAN_EQUAL",
              key: "bankingSlotInjects_slotStartAt",
              value: values.injectionEndTime && values.injectionEndTime,
            },
            bankingSlotInjects_slotEndAt: {
              operation: "GREATER_THAN_EQUAL",
              key: "bankingSlotInjects_slotEndAt",
              value: values.injectionStartTime && values.injectionStartTime,
            },
            bankingSlotDrawls_dateStartAt: {
              operation: "LESS_THAN_EQUAL",
              key: "bankingSlotDrawls_dateStartAt",
              value:
                values.drawlDateRange &&
                moment(values.drawlDateRange[1]).format("DD-MMM-yyyy"),
            },
            bankingSlotDrawls_dateEndAt: {
              operation: "GREATER_THAN_EQUAL",
              key: "bankingSlotDrawls_dateEndAt",
              value:
                values.drawlDateRange &&
                moment(values.drawlDateRange[0]).format("DD-MMM-yyyy"),
            },
            bankingSlotDrawls_slotStartAt: {
              operation: "LESS_THAN_EQUAL",
              key: "bankingSlotDrawls_slotStartAt",
              value: values.drawlEndTime && values.drawlEndTime,
            },
            bankingSlotDrawls_slotEndAt: {
              operation: "GREATER_THAN_EQUAL",
              key: "bankingSlotDrawls_slotEndAt",
              value: values.drawlStartTime && values.drawlStartTime,
            },
            bankingFactor: {
              operation: "BETWEEN",
              key: "bankingFactor",
              value: values.bankingFactor[0],
              value1: values.bankingFactor[1],
            },
            timeOfDrawlFactor: {
              operation: "BETWEEN",
              key: "timeOfDrawlFactor",
              value: values.timeOfDrawlFactor[0],
              value1: values.timeOfDrawlFactor[1],
            },
          };
          const reqBody = {
            search: [
              values.bankingFactor[0] !== null &&
                values.bankingFactor[1] !== null &&
                filteredData?.bankingFactor,
              values.timeOfDrawlFactor[0] !== null &&
                values.timeOfDrawlFactor[1] !== null &&
                filteredData?.timeOfDrawlFactor,
              values.energy[0] !== null &&
                values.energy[1] !== null &&
                filteredData?.energy,
              values.sellingCost[0] !== null &&
                values.sellingCost[1] !== null &&
                filteredData?.sellingCost,
              values.matchPercentage && filteredData.matchPercentage,
              values.energyRate && filteredData.energyRate,
              values.landingCostRange[0] !== null &&
                values.landingCostRange[1] !== null &&
                filteredData.landingCostRange,
              values.creditRatingId && filteredData.creditRatingId,
              values.connectionStatus !== "" && filteredData.connectionStatus,
              values.dateRange && filteredData?.dateStartAt,
              values.dateRange && filteredData?.dateEndAt,
              values.startTime && filteredData?.slotEndAt,
              values.endTime && filteredData?.slotStartAt,
              values.injectionDateRange &&
                filteredData?.bankingSlotInjects_dateStartAt,
              values.injectionDateRange &&
                filteredData?.bankingSlotInjects_dateEndAt,
              values.injectionStartTime &&
                filteredData?.bankingSlotInjects_slotStartAt,
              values.injectionEndTime &&
                filteredData?.bankingSlotInjects_slotEndAt,
              values.drawlDateRange &&
                filteredData?.bankingSlotDrawls_dateStartAt,
              values.drawlDateRange &&
                filteredData?.bankingSlotDrawls_dateEndAt,
              values.drawlStartTime &&
                filteredData?.bankingSlotDrawls_slotStartAt,
              values.drawlEndTime && filteredData?.bankingSlotDrawls_slotEndAt,
              values.energyTypeId &&
                (role === "CONSUMER" || role === "UN_VERIFIED_CONSUMER"
                  ? filteredData?.generatorEnergyTypeId
                  : role === "GENERATOR" || role === "UN_VERIFIED_GENERATOR"
                  ? filteredData?.consumerEnergyTypeId
                  : role === "BANKING"
                  ? filteredData?.discomEnergyTypeId
                  : false),
            ].filter(Boolean),
          };
          if (role === "CONSUMER" || role === "UN_VERIFIED_CONSUMER") {
            getAllListingsConsumerLogin(reqBody)(dispatch);
          } else if (role === "GENERATOR" || role === "UN_VERIFIED_GENERATOR") {
            getAllListingsGeneratorLogin(reqBody)(dispatch);
          } else if (role === "BANKING") {
            getMatchingBankingListings(selectedCardData?.id, reqBody);
          }
          window.scrollTo({ top: 0, behavior: "smooth" });
          setSubmitting(false);
        }}
      >
        {({
          values,
          errors,
          setFieldValue,
          setFieldTouched,
          handleBlur,
          resetForm,
          submitForm,
        }) => {
          // console.log("filter_Form_values==>",{values,errors})
          return (
            <Form>
              {currentRoute !== "/banking" ? (
                <div className="dashboard-filter">
                  <h5>Filters</h5>
                  <div className="filter-inputLabel">
                    <p className="filter-inputLabelText">Date Range</p>
                  </div>
                  <div className="filter-slider-dateRange">
                    <DateRangePicker
                      name="dateRange"
                      format="dd-MMM-yyyy"
                      character=" to "
                      size="lg"
                      placeholder="Select Date Range"
                      showOneCalendar
                      onChange={(e) => {
                        setFieldValue("dateRange", e);
                      }}
                      onClean={() => submitForm()}
                      className="rs-picker-custom-styles"
                      value={values.dateRange}
                      ranges={predefinedRanges}
                      shouldDisableDate={beforeToday()}
                    />
                  </div>
                  <div className="filter-inputLabel">
                    <p className="filter-inputLabelText">Time Range</p>
                  </div>
                  <div className="">
                    <div className="custom-timeInput">
                      <label>Start Time</label>
                      <CustomTimePicker
                        minutesStep={15}
                        updateTimeToParent={(timeText) => {
                          setFieldValue("startTime", timeText);
                        }}
                        time={values.startTime}
                        maxHours={24}
                      />
                    </div>
                    <div className="custom-timeInput">
                      <label>End Time</label>
                      <CustomTimePicker
                        name="endTime"
                        minutesStep={15}
                        updateTimeToParent={(timeText) => {
                          setFieldValue("endTime", timeText);
                        }}
                        time={values.endTime}
                        minTime={values.startTime}
                        minTimeDiffInMinutes={15}
                        maxHours={25}
                      />
                      {/* <ErrorMessage name="endTime" component="div" className="text-danger" /> */}
                    </div>
                  </div>
                  <div className="filter-inputLabel">
                    <p className="filter-inputLabelText">Quantity (in MW)</p>
                  </div>
                  <div className="filter-slider">
                    <Box>
                      <Slider
                        className="matchPercentage"
                        name="energy"
                        getAriaLabel={() => "Temperature range"}
                        value={values.energy}
                        onChange={(e) => {
                          setFieldValue("energy", e.target.value);
                        }}
                        valueLabelDisplay="on"
                        color="warning"
                        size="small"
                        // getAriaValueText={valuetext}
                      />
                    </Box>
                  </div>

                  {role === "CONSUMER" && (
                    <>
                      <div className="filter-inputLabel">
                        <p className="filter-inputLabelText">
                          Energy Rate (₹ per Unit)
                        </p>
                      </div>
                      <div className="filter-slider">
                        <Box>
                          <Slider
                            className="matchPercentage"
                            name="sellingCost"
                            getAriaLabel={() => "Temperature range"}
                            value={values.sellingCost}
                            onChange={(e) => {
                              setFieldValue("sellingCost", e.target.value);
                            }}
                            valueLabelDisplay="on"
                            color="warning"
                            size="small"
                            // getAriaValueText={valuetext}
                          />
                        </Box>
                      </div>
                    </>
                  )}
                  {role === "GENERATOR" && (
                    <>
                      <div className="filter-inputLabel">
                        <p className="filter-inputLabelText">
                          Energy Rate (₹ per Unit)
                        </p>
                      </div>
                      <div className="filter-slider">
                        <Box>
                          <Slider
                            className="matchPercentage"
                            name="landingCostRange"
                            getAriaLabel={() => "Temperature range"}
                            value={values.landingCostRange}
                            onChange={(e) => {
                              setFieldValue("landingCostRange", e.target.value);
                            }}
                            valueLabelDisplay="on"
                            color="warning"
                            size="small"
                            // getAriaValueText={valuetext}
                          />
                        </Box>
                      </div>
                    </>
                  )}
                  <div className="filter-inputLabel">
                    <p className="filter-inputLabelText">Energy Type</p>
                  </div>
                  <Box>
                    <select
                      name="energyTypeId"
                      onChange={(e) =>
                        setFieldValue("energyTypeId", e.target.value)
                      }
                      value={values.energyTypeId}
                      className="custom-selectInput-cr"
                    >
                      <option value="">Select Energy Type</option>
                      {energyTypes?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.type}
                        </option>
                      ))}
                    </select>
                  </Box>
                  <div className="filter-inputLabel">
                    <p className="filter-inputLabelText"> Credit Rating</p>
                  </div>
                  <Box>
                    <select
                      name="creditRatingId"
                      onChange={(e) =>
                        setFieldValue("creditRatingId", e.target.value)
                      }
                      value={values.creditRatingId}
                      className="custom-selectInput-cr"
                    >
                      <option value="">Select Credit Rating</option>
                      {credit?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.rating}
                        </option>
                      ))}
                    </select>
                  </Box>
                  <hr></hr>
                  <div style={{ marginLeft: "15px" }}>
                    <button
                      type="submit"
                      className="btn btn-signup btn-primary"
                    >
                      Search
                    </button>
                    <button
                      type="submit"
                      style={{ marginLeft: "15px" }}
                      className="btn btn-login btn-primary"
                      onClick={() => {
                        resetForm();
                        handleFormReset();
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              ) : (
                <div className="dashboard-filter">
                  <h5>Filters</h5>
                  <div className="filter-inputLabel">
                    <p className="filter-inputLabelText">
                      Injection Date Range
                    </p>
                  </div>
                  <div className="filter-slider-dateRange">
                    <DateRangePicker
                      name="injectionDateRange"
                      format="dd-MMM-yyyy"
                      character=" to "
                      size="lg"
                      placeholder="Select Injection Date Range"
                      showOneCalendar
                      onChange={(e) => {
                        setFieldValue("injectionDateRange", e);
                      }}
                      onClean={() => submitForm()}
                      className="rs-picker-custom-styles"
                      value={values.injectionDateRange}
                      ranges={predefinedRanges}
                      shouldDisableDate={beforeToday()}
                    />
                  </div>
                  <div className="filter-inputLabel">
                    <p className="filter-inputLabelText">
                      Injection Time Range
                    </p>
                  </div>
                  <div className="">
                    <div className="custom-timeInput">
                      <label>Start Time</label>
                      <CustomTimePicker
                        minutesStep={15}
                        updateTimeToParent={(timeText) => {
                          setFieldValue("injectionStartTime", timeText);
                        }}
                        time={values.injectionStartTime}
                        maxHours={24}
                      />
                    </div>
                    <div className="custom-timeInput">
                      <label>End Time</label>
                      <CustomTimePicker
                        name="injectionEndTime"
                        minutesStep={15}
                        updateTimeToParent={(timeText) => {
                          setFieldValue("injectionEndTime", timeText);
                        }}
                        time={values.injectionEndTime}
                        minTime={values.injectionStartTime}
                        minTimeDiffInMinutes={15}
                        maxHours={25}
                      />
                      {/* <ErrorMessage name="endTime" component="div" className="text-danger" /> */}
                    </div>
                  </div>
                  <div className="filter-inputLabel">
                    <p className="filter-inputLabelText">Drawal Date Range</p>
                  </div>
                  <div className="filter-slider-dateRange">
                    <DateRangePicker
                      name="drawlDateRange"
                      format="dd-MMM-yyyy"
                      character=" to "
                      size="lg"
                      placeholder="Select Drawal Date Range"
                      showOneCalendar
                      onChange={(e) => {
                        setFieldValue("drawlDateRange", e);
                      }}
                      onClean={() => submitForm()}
                      className="rs-picker-custom-styles"
                      value={values.drawlDateRange}
                      ranges={predefinedRanges}
                      shouldDisableDate={beforeToday()}
                    />
                  </div>
                  <div className="filter-inputLabel">
                    <p className="filter-inputLabelText">Drawal Time Range</p>
                  </div>
                  <div className="">
                    <div className="custom-timeInput">
                      <label>Start Time</label>
                      <CustomTimePicker
                        minutesStep={15}
                        updateTimeToParent={(timeText) => {
                          setFieldValue("drawlStartTime", timeText);
                        }}
                        time={values.drawlStartTime}
                        maxHours={24}
                      />
                    </div>
                    <div className="custom-timeInput">
                      <label>End Time</label>
                      <CustomTimePicker
                        name="drawlEndTime"
                        minutesStep={15}
                        updateTimeToParent={(timeText) => {
                          setFieldValue("drawlEndTime", timeText);
                        }}
                        time={values.drawlEndTime}
                        minTime={values.drawlStartTime}
                        minTimeDiffInMinutes={15}
                        maxHours={25}
                      />
                      {/* <ErrorMessage name="endTime" component="div" className="text-danger" /> */}
                    </div>
                  </div>
                  <div className="filter-inputLabel">
                    <p className="filter-inputLabelText">Banking Factor (%)</p>
                  </div>
                  <div className="filter-slider">
                    <Box>
                      <Slider
                        className="matchPercentage"
                        name="bankingFactor"
                        getAriaLabel={() => "Temperature range"}
                        value={values.bankingFactor}
                        onChange={(e) => {
                          setFieldValue("bankingFactor", e.target.value);
                        }}
                        valueLabelDisplay="on"
                        color="warning"
                        size="small"
                        // getAriaValueText={valuetext}
                      />
                    </Box>
                  </div>

                  {/* <>
                    <div className="filter-inputLabel">
                      <p className="filter-inputLabelText">
                        Time of Drawal Factor (%)
                      </p>
                    </div>
                    <div className="filter-slider">
                      <Box>
                        <Slider
                          className="matchPercentage"
                          name="timeOfDrawlFactor"
                          getAriaLabel={() => "Temperature range"}
                          value={values.timeOfDrawlFactor}
                          onChange={(e) => {
                            setFieldValue("timeOfDrawlFactor", e.target.value);
                          }}
                          valueLabelDisplay="on"
                          color="warning"
                          size="small"
                          // getAriaValueText={valuetext}
                        />
                      </Box>
                    </div>
                  </> */}
                  <div className="filter-inputLabel">
                    <p className="filter-inputLabelText">Energy Type</p>
                  </div>
                  <Box>
                    <select
                      name="energyTypeId"
                      onChange={(e) =>
                        setFieldValue("energyTypeId", e.target.value)
                      }
                      value={values.energyTypeId}
                      className="custom-selectInput-cr"
                    >
                      <option value="">Select Energy Type</option>
                      {energyTypes?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.type}
                        </option>
                      ))}
                    </select>
                  </Box>
                  <div className="filter-inputLabel">
                    <p className="filter-inputLabelText"> Credit Rating</p>
                  </div>
                  <Box>
                    <select
                      name="creditRatingId"
                      onChange={(e) =>
                        setFieldValue("creditRatingId", e.target.value)
                      }
                      value={values.creditRatingId}
                      className="custom-selectInput-cr"
                    >
                      <option value="">Select Credit Rating</option>
                      {credit?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.rating}
                        </option>
                      ))}
                    </select>
                  </Box>
                  <hr></hr>
                  <div style={{ marginLeft: "15px" }}>
                    <button
                      type="submit"
                      className="btn btn-signup btn-primary"
                    >
                      Apply
                    </button>
                    <button
                      type="submit"
                      style={{ marginLeft: "15px" }}
                      className="btn btn-login btn-primary"
                      onClick={() => {
                        resetForm();
                        handleFormReset();
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              )}
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default ListingsSearchFilter;
